<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="clearfix">
        <!-- <h1 class="float-left display-3 mr-4">404</h1> -->
        <h4 class="pt-3">{{ 'admin.alerts.oopsLostMsg' | translate }}</h4>
        <div>
          <p class="text-muted">
            {{ 'admin.alerts.correctURLMsg' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
